"use client";

import { useState } from "react";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { Button } from "@/shared/components/common/button";
import Input from "@/shared/components/common/input/Input";
import staticData from "@/public/data/hotel/detail.json";

export default function Discount() {
  const [discountCode, setDiscountCode] = useState("");

  const { discount } = staticData.sidebarCard.body;

  return (
    <Flex className="flex-col gap-y-6">
      <Flex className="gap-x-4 justify-between">
        <Input
          placeholder={discount.input.label}
          value={discountCode}
          className="rounded-xs"
          onChange={(e) => setDiscountCode(e.target.value)}
        />

        <Button
          className="h-full border-2 border-primary bg-transparent! text-primary! hover:bg-primary! hover:text-background!"
          disabled={discountCode.length === 0}
        >
          {discount.input.button}
        </Button>
      </Flex>

      <Flex className="justify-between">
        <Typography variant="body2" className="font-medium">
          {discount.label}
        </Typography>

        {/* Add the discount later */}
        <Flex className="gap-x-2">
          <Typography variant="body2" className="">
            {0}
          </Typography>
          <Typography variant="body2">{discount.currencyLabel}</Typography>
        </Flex>
      </Flex>
    </Flex>
  );
}
